import {
  CheckListId,
  CheckListItemType,
  RepeatedCheckListDataSchema,
} from '@web/common';

const commonFields = {
  done: false,
};

export const defaultRepeatedQuestionnaireChecklist: RepeatedCheckListDataSchema =
  {
    [CheckListId.CannabisConsumptionQuestionnaire]: {
      type: CheckListItemType.QuestionnaireCannabisConsumption,
      ...commonFields,
    },
    [CheckListId.SF12Questionnaire]: {
      type: CheckListItemType.Questionnaire12SF,
      ...commonFields,
    },
  };

// Function to apply default values to the checklist data if it doesn't match the schema
export function applyDefaultValues(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checklistData: any,
): RepeatedCheckListDataSchema {
  const defaultData: RepeatedCheckListDataSchema = {
    ...defaultRepeatedQuestionnaireChecklist,
  };

  for (const key in checklistData.data) {
    if (
      key in defaultData &&
      Object.prototype.hasOwnProperty.call(checklistData.data, key)
    ) {
      defaultData[key as keyof RepeatedCheckListDataSchema] = {
        ...defaultData[key as keyof RepeatedCheckListDataSchema],
        ...checklistData.data[key],
      };
    }
  }

  return defaultData;
}
